import { Dispatch } from "redux";
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getCategories = (page: number | null = null, limit: number | null = null, search: string = '') => async (dispatch: Dispatch) => {
    dispatch({
        type: 'CATEGORY_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/category/getall/', { page, limit, search }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'CATEGORY_GETALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({
                type: 'CATEGORY_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CATEGORY_NOT_LOADING'
        })
    }
}

export const getForSelect = () => async (dispatch: Dispatch) => {
    dispatch({ type: 'CATEGORY_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/category/getforselect/', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'CATEGORY_GETALLFORSELECT_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'CATEGORY_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'CATEGORY_NOT_LOADING' })
    }
}

export const getCategory = (category: any) => async (dispatch: Dispatch) => {
    dispatch({
        type: 'CATEGORY_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/category/get/'+ category, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'CATEGORY_GET_SUCCESS',
                payload: data
            })
        } else {
            dispatch({
                type: 'CATEGORY_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CATEGORY_NOT_LOADING'
        })
    }
}

export const addCategory = (categorydata: any) => async (dispatch: Dispatch) => {
    try {
        const { data, status} = await Axios.post('/api/category/register', categorydata, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CATEGORY_ADD_SUCCESS',
                payload: data
            })
        } else {
            if (status === 264 || status === 260) {
                dispatch({
                    type: 'CATEGORY_WRONG_SUCCESS',
                    payload: data
                })
            }else{
                dispatch({
                    type: 'CATEGORY_NOT_LOADING'
                })
            }
        }
    } catch (error) {
        dispatch({
            type: 'CATEGORY_NOT_LOADING'
        })
    }
}

export const editCategory = (categorydata: any, category: string) => async (dispatch: Dispatch) => {
    try {
        const { data, status} = await Axios.put('/api/category/edit/' + category, categorydata, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CATEGORY_EDIT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'CATEGORY_NOT_LOADING'
        })
    }
}

export const deleteCategory = (category: string) => async (dispatch: Dispatch) => {
    try {
        const { data, status} = await Axios.delete('/api/category/delete/' + category, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CATEGORY_DELETE_SUCCESS',
                payload: {...data, idCategory: category}
            })
        } else {
            if (status === 266) {
                dispatch({
                    type: 'CATEGORY_DELETE_INUSE',
                    payload: data
                })
            }else{
                dispatch({
                    type: 'CATEGORY_NOT_LOADING'
                })
            }
        }
    } catch (error) {
        dispatch({
            type: 'CATEGORY_NOT_LOADING'
        })
    }
}